import { DownloadOutlined } from "@ant-design/icons";
import { Table, Space } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { serverUrl } from "../../../../../nestserver";

const StudentMontessoriReportList = () => {
  const navigate = useNavigate();
  const [downloadingId, setDownloadingId] = useState(null);

  const handleDownload = async (id, templateName) => {
    try {
      setDownloadingId(id);
      const res = await axios({
        method: "get",
        url: `${serverUrl}/montessori-progress-card/${id}/download`,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        },
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Montessori_Report_${templateName}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.log("Error downloading PDF:", error);
    } finally {
      setDownloadingId(null);
    }
  };

  // fetch student's montessori cards
  const getCards = useQuery("montessori-cards-student", () =>
    axios({
      method: "get",
      url: `${serverUrl}/montessori-progress-card/by-student`,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    }).then((res) => res.data),
  );

  const columns = [
    {
      title: "Template",
      dataIndex: [],
      key: "template",
      align: "center",
      render: (record) => (
        <div
          style={{ color: "#111111" }}
          className="text-base text-center capitalize"
        >
          {record?.template?.name}
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: [],
      key: "status",
      align: "center",
      render: (record) => {
        const metadata = record?.term_metadata || [];
        const notifiedTerms = metadata.filter(
          (m) => m.status === "notified" || m.status === "acknowledged",
        );
        return (
          <div
            style={{ color: "#111111" }}
            className="text-base text-center capitalize"
          >
            {notifiedTerms.length > 0
              ? `${notifiedTerms.length} Term(s) Available`
              : "No Reports Released"}
          </div>
        );
      },
    },
    {
      title: "Latest Release",
      dataIndex: [],
      key: "last_notified",
      align: "center",
      render: (record) => {
        const metadata = record?.term_metadata || [];
        const latest = metadata
          .filter((m) => m.notified_at)
          .sort((a, b) => new Date(b.notified_at) - new Date(a.notified_at))[0];

        return (
          <div style={{ color: "#111111" }} className="text-base text-center">
            {latest?.notified_at
              ? moment(latest.notified_at).format("DD MMMM YYYY")
              : "--"}
          </div>
        );
      },
    },
    {
      title: "Action",
      dataIndex: [],
      key: "action",
      align: "center",
      render: (record) => {
        const isDownloading = downloadingId === record?._id;
        return (
          <Space size="middle">
            <div
              className="text-base font-semibold text-center text-blue-500 cursor-pointer"
              onClick={() =>
                navigate(
                  `/dashboard/student/menu/montessori-report-card/${record?._id}`,
                )
              }
            >
              View
            </div>
            <div
              className={`text-base font-semibold text-center flex items-center gap-1 ${
                isDownloading
                  ? "text-gray-400 cursor-not-allowed"
                  : "text-orange-500 cursor-pointer"
              }`}
              onClick={() =>
                !isDownloading &&
                handleDownload(record?._id, record?.template?.name)
              }
            >
              <DownloadOutlined />{" "}
              {isDownloading ? "Downloading..." : "Download"}
            </div>
          </Space>
        );
      },
    },
  ];

  return (
    <>
      <div className="p-8">
        <div
          style={{ borderRadius: "10px", color: "#616161" }}
          className="bg-white drop-shadow-md p-8 w-full"
        >
          <div className="text-2xl text-orange-500 font-semibold pb-8">
            My Montessori Report Card
          </div>
          <div className="py-5">
            <Table
              rowKey="_id"
              columns={columns}
              dataSource={
                getCards?.isSuccess && getCards?.data?.result
                  ? getCards?.data?.result
                  : []
              }
              pagination={true}
              loading={getCards?.isLoading}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentMontessoriReportList;
